import {
  FETCH_USERS,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_ERROR
} from '../actions';


export const fetchUsers = () => ({
  type: FETCH_USERS
});

export const fetchUsersSuccess = data => ({
  type: FETCH_USERS_SUCCESS,
  payload: {
    data
  }
});

export const fetchUsersError = error => ({
  type: FETCH_USERS_ERROR,
  payload: {
    error
  }
});
